import { Dispatch, SetStateAction } from 'react';
import { getMultisortFromDataset } from './managerUtils';

export const processFetchedSlaveDataset = (
  response: any,
  subsetId: string,
  setSlaveDatasets: Dispatch<SetStateAction<any>>,
  setSlaveLazyStates: Dispatch<SetStateAction<any>>
) => {
  if (response) {
    setSlaveDatasets((v) => ({ ...v, [subsetId]: response }));
    const multiSortMeta = getMultisortFromDataset(response);
    if (multiSortMeta) {
      setSlaveLazyStates((oldLazyState) => {
        const newSlaveLazyState = {
          ...oldLazyState[subsetId],
          multiSortMeta: multiSortMeta,
        };
        return {
          ...oldLazyState,
          [subsetId]: newSlaveLazyState,
        };
      });
    }
  }
};
